import { useTranslation } from 'react-i18next'

import { PageEmptyState } from '../../../PageEmptyState'
import Text from '../../../Text'

import * as styles from './DocFlowCombiningProgress.module.css'

import DocIcon from '../../../../icons/doc-splitting.svg'

function DocFlowCombiningProgress({ loadingPercent }) {
  const { t } = useTranslation()

  return (
    <PageEmptyState EntityIcon={DocIcon}>
      <Text isSecondary className={styles.text}>
        {t('DocumentStapling.CombiningProgressTextKey', {
          count: loadingPercent,
        })}
      </Text>
      <span
        className={styles.loader}
        style={{
          '--doc-flow-loading-combining-percent': loadingPercent,
        }}
      />
    </PageEmptyState>
  )
}

export default DocFlowCombiningProgress
